// DevHub UI kit — catalog constants + helpers.
//
// Centralises the "kinds the software catalog excludes" list (plumbing/org kinds
// discovered by the Azure DevOps provider) and a canonical entityRef helper,
// replacing the hand-rolled `${kind}:${ns}/${name}` idiom used as a React key /
// ref across the catalog and docs grids.
import { Entity, stringifyEntityRef } from '@backstage/catalog-model';

/**
 * Kinds excluded from the software catalog browse surfaces:
 *  - `Location` — auto-generated by the Azure DevOps discovery provider.
 *  - `User` / `Group` — org data (people/teams), not software entities.
 * (McpServer entities DO appear here — they're first-class software; the MCP
 * Marketplace is just a dedicated view of the same entities.)
 */
export const NON_SOFTWARE_KINDS: readonly string[] = [
  'Location',
  'User',
  'Group',
];

/**
 * Canonical entity reference (`kind:namespace/name`, lowercased) — a stable
 * React key and the same ref Backstage's star store keys off. Use this instead of
 * hand-building the string so namespace defaulting and casing stay in one place.
 */
export function entityRef(entity: Entity): string {
  return stringifyEntityRef(entity);
}
